import { Flagship } from '../main/Flagship';
import { logErrorSprintf } from '../utils/utils';
export class VisitorProfileCache {
    _sdkConfig;
    constructor(sdkConfig) {
        this._sdkConfig = sdkConfig;
    }
    saveVisitorProfile(visitorProfile) {
        try {
            const extendedFlagship = Flagship;
            const onSaveVisitorProfile = extendedFlagship.getOnSaveVisitorProfile();
            onSaveVisitorProfile?.(JSON.stringify(visitorProfile));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            logErrorSprintf(this._sdkConfig, 'VisitorProfileCache.saveVisitorProfile', error?.message);
        }
    }
    loadVisitorProfile() {
        try {
            const extendedFlagship = Flagship;
            const data = extendedFlagship.getVisitorProfile();
            return data ? JSON.parse(data) : null;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            logErrorSprintf(this._sdkConfig, 'VisitorProfileCache.loadVisitorProfile', error?.message);
        }
        return null;
    }
}
